/**
 * Hard limits for Word import. Sized so a hostile or huge file fails cleanly
 * on a 4 GB school Chromebook instead of exhausting memory.
 */
export const DEFAULT_LIMITS = Object.freeze({
    maxInputBytes: 50 * 1024 * 1024,
    maxInputBytesMainThread: 10 * 1024 * 1024,
    maxEntries: 5000,
    maxDocumentXmlBytes: 48 * 1024 * 1024,
    maxPartXmlBytes: 16 * 1024 * 1024,
    maxTotalXmlBytes: 64 * 1024 * 1024,
    /** Compression ratio cap, applied to entries larger than ratioCheckBytes. */
    maxRatio: 100,
    ratioCheckBytes: 1024 * 1024,
    maxImageBytes: 15 * 1024 * 1024,
    maxTotalImageBytes: 100 * 1024 * 1024,
    maxImages: 300,
    maxXmlDepth: 200,
    maxXmlElements: 3000000,
    maxTableNesting: 8,
    maxOutputHtmlBytes: 8 * 1024 * 1024,
});

/** Worker hard timeout: 20 s + 2 s per MB, clamped to 30–120 s. */
export function conversionTimeoutMs(byteLength) {
    const ms = 20000 + 2000 * (byteLength / (1024 * 1024));
    return Math.min(120000, Math.max(30000, Math.round(ms)));
}

export const WATCHDOG_MS = 20000;
export const UPLOAD_TIMEOUT_MS = 60000;
export const UPLOAD_CONCURRENCY = 3;
export const IMPORT_TIMEOUT_MS = 5 * 60 * 1000;
